import React, { useState } from "react";
import classNames from "classnames";
import { Control, Controller } from "react-hook-form";
import { ClientInfoForm } from "features/ClientInfo/ClientInfo";

import { Calendar } from "components/Calendar/Calendar";
import { NamedInput } from "components/NamedInput/NamedInput";
import RadioButton from "components/Radio/Radio";

import styles from "../../styles.module.css";

type FieldItem = {
  varName: keyof ClientInfoForm;
  text: string;
};

type Props = {
  control: Control<ClientInfoForm>;
};

const FIELDS = [
  { varName: "secondname", text: "Фамилия" },
  { varName: "firstname", text: "Имя" },
  { varName: "otc", text: "Отчество" },
  { varName: "phone", text: "Телефон" },
  { varName: "email", text: "E-mail" },
  { varName: "card", text: "Карта" },
  { varName: "city", text: "Город" },
  { varName: "address", text: "Улица" },
] as FieldItem[];

const SMALL_FIELDS = [
  { varName: "house", text: "Д" },
  { varName: "korpus", text: "Кор" },
  { varName: "flat", text: "Кв" },
] as FieldItem[];

const SEX_RADIO = [
  { value: "1", text: "М" },
  { value: "2", text: "Ж" },
];

export const IndividualClient = ({ control }: Props): JSX.Element => {
  const [calendarVisible, setCalendarVisible] = useState<boolean>(false);

  return (
    <>
      <h3 className={styles.user_type_title}>Физическое лицо</h3>
      <div className="flex flex-wrap h-60">
        {FIELDS.map((item) => (
          <div
            key={item.varName}
            className={classNames("mb-2.5", styles.inputContainer)}
          >
            <Controller
              control={control}
              name={item.varName}
              render={({ field }) => (
                <NamedInput
                  {...field}
                  value={field.value as string}
                  classNameContainer="mr-6"
                  inputWidth={160}
                  label={item.text}
                />
              )}
            />
          </div>
        ))}
        {SMALL_FIELDS.map((item) => (
          <div key={item.varName} className="mb-2.5">
            <Controller
              control={control}
              name={item.varName}
              render={({ field }) => (
                <NamedInput
                  {...field}
                  value={field.value as string}
                  className="text-sm h-10"
                  classNameContainer="mr-3"
                  labelClassName="mr-2"
                  inputWidth={42}
                  label={item.text}
                />
              )}
            />
          </div>
        ))}

        <div className="flex items-center gap-6 mr-24">
          <span className={styles.birth_date_label}>Дата рождения:</span>
          <Controller
            name="birthday"
            control={control}
            render={({ field }) => (
              <Calendar
                onShow={() => setCalendarVisible(!calendarVisible)}
                setVisibleCalendar={setCalendarVisible}
                visibleCalendar={calendarVisible}
                onChange={(e) => {
                  field.onChange(e);
                }}
                value={field.value ? new Date(field.value) : null}
                calendarProps={{
                  defaultActiveStartDate: new Date(1980, 0, 1),
                  defaultView: "decade",
                }}
              />
            )}
          />
        </div>
        {SEX_RADIO.map((item) => (
          <Controller
            key={item.value}
            name="sex"
            control={control}
            render={({ field }) => (
              <RadioButton
                id={item.value + "-" + item.text}
                text={item.text}
                name={"sex"}
                onChange={() => {
                  field.onChange(item.value);
                }}
                checked={field.value === item.value}
                value={item.value}
                className="mr-4"
              />
            )}
          />
        ))}
      </div>
    </>
  );
};
